import { defineComponent as _defineComponent } from 'vue'
import { appName } from './config.ts'
import {
  NcSettingsSection,
} from '@nextcloud/vue'
import { translate as t } from '@nextcloud/l10n'
import TextField from '@rotdrop/nextcloud-vue-components/lib/components/TextFieldWithSubmitButton.vue'
import cloudVersionClassesImport from './toolkit/util/cloud-version-classes.ts'
import {
  fetchSettings,
  saveConfirmedSetting,
  saveSimpleSetting,
} from './toolkit/util/settings-sync.ts'
import {
  reactive,
  ref,
  computed,
} from 'vue'
import logger from './logger.ts'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminSettings',
  setup(__props) {

const loading = ref(0)
const cloudVersionClasses = computed<string[]>(() => cloudVersionClassesImport)
const settings = reactive({
  externalLocation: '',
  enableSSLVerify: false,
  authenticationRefreshInterval: 0,
})

// slurp in all settings
const getData = async () => {
  ++loading.value
  return fetchSettings({ section: 'admin', settings }).finally(() => {
    logger.info('SETTINGS', settings)
    --loading.value
  })
}
getData()

const saveTextInput = async (settingsKey: string, value?: string | number | boolean, force?: boolean) => {
  if (value === undefined) {
    value = settings[settingsKey] || ''
  }
  if (loading.value > 0) {
    // avoid ping-pong by reactivity
    logger.info('SKIPPING SETTINGS-SAVE DURING LOAD', settingsKey, value)
    return
  }
  return saveConfirmedSetting({ value, section: 'admin', settingsKey, force, settings, resetData: getData })
}

const saveSetting = async (settingsKey: string) => {
  if (loading.value > 0) {
    // avoid ping-pong by reactivity
    logger.info('SKIPPING SETTINGS-SAVE DURING LOAD', settingsKey)
    return
  }
  saveSimpleSetting({ settingsKey, section: 'admin', settings })
}

return { __sfc: true,loading, cloudVersionClasses, settings, getData, saveTextInput, saveSetting, appName, NcSettingsSection, t, TextField }
}

})